import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Select from "../../../../components/Select";
import { ADDITIONAL_INFO_OPTIONS } from "../../../../common/utils/utils";

const GNOMAD_AF_THRESHOLD = 0.02;

const ClassSelectors = (props) => {
  const {
    flag,
    additionalInfo,
    infoPropertyChanged,
    flagPropertyChanged,
    variantClassesList,
    gnomad,
  } = props;
  const [options, setOptions] = useState("");
  const [af, setAf] = useState(null);

  const filteredVariantClasses = () => {
    let vc;
    if (variantClassesList) {
      vc = variantClassesList.map((c) => ({
        value: c.short_name,
        label: c.name,
      }));
      let afreq = null;
      if (Array.isArray(gnomad) && gnomad.length > 0) {
        afreq = gnomad[0].af;
        setAf(afreq);
      }
      if (afreq && afreq > GNOMAD_AF_THRESHOLD) {
        vc = vc.filter((c) => {
          return !c.hideForCommon || flag.value === c.value;
        });
      }
    }
    setOptions(vc);
  };

  useEffect(() => {
    filteredVariantClasses();
  }, [variantClassesList, gnomad]);

  return (
    <div className="tw-mb-8">
      <div>
        <p className="tw-text-base tw-mb-0">
          Select a classification for the variant you are currently viewing.
          <span className="tw-text-xs tw-block tw-italic">
            You will be able to edit and/or remove your classification at any
            time.
          </span>
        </p>
        {af > GNOMAD_AF_THRESHOLD && (
          <p className="varsome-text-muted tw-mb-2">
            <i className="fa fa-exclamation-triangle" /> Some options may not be
            available as this is a common variant
          </p>
        )}
      </div>
      <div>
        <div className="tw-flex tw-justify-start tw-items-start">
          <Select
            value={flag}
            onChange={(e) => flagPropertyChanged(e)}
            options={options}
            placeholder="Select variant pathogenicity..."
            className="tw-mr-3"
          />
          <Select
            isMulti={true}
            value={additionalInfo}
            onChange={(e) => infoPropertyChanged(e)}
            options={ADDITIONAL_INFO_OPTIONS}
            placeholder="Additional variant information..."
          />
        </div>
      </div>
    </div>
  );
};

ClassSelectors.propTypes = {
  infoPropertyChanged: PropTypes.func.isRequired,
  flagPropertyChanged: PropTypes.func.isRequired,
  flag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ]),
  additionalInfo: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  variantClassesList: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      description: PropTypes.string,
      hideForCommon: PropTypes.bool,
      name: PropTypes.string,
      short_name: PropTypes.string,
    })
  ),
  gnomad: PropTypes.arrayOf(
    PropTypes.shape({
      af: PropTypes.number,
    })
  ),
};

ClassSelectors.defaultProps = {
  flag: null,
  additionalInfo: null,
  variantClassesList: null,
  gnomad: null,
};

const mapStateToProps = (state) => {
  return {
    variantClassesList: state.variantClassesList,
    gnomad: state.variantResult?.gnomad_genomes,
  };
};

export default connect(mapStateToProps, {})(ClassSelectors);
